// Vue.prototype.StarLoading = function(that, text, target) {
//     that.loading = {
//         lock: true,
//         text: text || "拼命加载中",
//         // target: target ? target : ".warp_content",
//         spinner: "el-icon-loading",
//         background: "rgba(0, 0, 0, 0.6)"
//     };
//     $Loading.service(that.loading);
//     setTimeout(() => {
//         if (that.loading) {
//             that.loading.close();
//         }
//         that.loading = null;
//     }, 10000);
// };
// Vue.prototype.CloseLoading = function(that) {
//     let Loading = $Loading.service(that.loading);
//     that.$nextTick(() => {
//         setTimeout(() => {
//             Loading.close();
//         }, 500);
//     });
// };

window.StarLoading = function(that, text, target, time) {
    var globalLoding = {
        lock: true,
        target: target ? target : ".warp_content",
        text: text || "正在加载,请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
    };
    that.globalLoding = null;
    that.globalLoding = $Loading.service(globalLoding);
    that.globalLodingTimer = setTimeout(
        () => {
            if (that.globalLoding) {
                that.globalLoding.close();
                that.$message.error("请求超时");
                that.globalLoding = null;
            }
        },
        time ? time * 1000 : 20000
    );
};
window.CloseLoading = function(that) {
    if (that.globalLodingTimer) {
        this.clearTimeout(that.globalLodingTimer);
        that.globalLodingTimer = null;
    }
    that.$nextTick(() => {
        setTimeout(() => {
            that.globalLoding && that.globalLoding.close();
            that.globalLoding = null;
        }, 500);
    });
};
